import react from "react";

export const reactApi = react;

